const jQ = jQuery.noConflict();

class setupMinimumPageHeight{

	constructor(){
		this.headerMain = ".header-main";
		this.footerMain = ".footer-main";
		this.content = ".content";
	}
	setupMinPageHeightFunc(){
		
		let headerFooterHeight = jQ(this.headerMain).outerHeight() + jQ(this.footerMain).outerHeight();
		let string = "calc(100vh - " + headerFooterHeight + "px)";

		jQ(this.content).css({
			'min-height': string 
		});
			
	}

	init(){
		this.setupMinPageHeightFunc();
	}

}

const setupMinPageH = new setupMinimumPageHeight();

export default setupMinPageH;


// WEBPACK FOOTER //
// ./app/themes/nordic-concert-halls/js/utils/setupminpageheight.js